export function hasPermission(
    userPermissions: Array<{ codename: string }>,
    permission: string
): boolean {
    return userPermissions.some((p) => p.codename === permission)
}
